// extracted by mini-css-extract-plugin
export default {"statsRow":"StatsRow-module__statsRow___1lQFb","divider":"StatsRow-module__divider___VTzJR"};